export class BasketPayerError extends Error {}
export class BasketPayerShippingError extends Error {}
